import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { FormGroup, FormBuilder } from '@angular/forms';
import { advertisement, ServiceService } from 'src/app/service.service';

@Component({
  selector: 'app-velocity',
  templateUrl: './velocity.page.html',
  styleUrls: ['./velocity.page.scss' , '../../../assets/scss/styles.scss'],
})
export class VelocityPage implements OnInit {
  previousResult: number = null;
  pulgada: number;
  rpm: number;
  result: number;
  tipo: string;
  mensaje: string;
  typeMessage: string;
  isMovil:boolean = false;
  advertisements:advertisement = new advertisement();
  velocity: FormGroup;

  constructor(private router: Router, public services: ServiceService, private form: FormBuilder) {
    this.velocity = this.form.group({
      cantidad: [''],
      valor: [''],
      tipo: ['']
    });
  }

  async ngOnInit() {
    let conta: number = 0;
    this.velocity.get('tipo').valueChanges.subscribe( res => {
      this.typeMessage = res;
      conta++;
      this.typeMessage = res;
      if (res === 'Diámetro ') {
        if (conta >1 ) {
          const valor = this.cemPulg(this.velocity.get('cantidad').value);
          this.velocity.get('cantidad').setValue(valor);
        }
      } else {
        if (conta >1 ) {
          const valor = this.PulugCem(this.velocity.get('cantidad').value);
          this.velocity.get('cantidad').setValue(valor);
        }
      }
    });

    this.isMovil = this.services.isMovil();
    if(!this.isMovil){
      this.advertisements = await this.services.getAdvertisementByScreen(8,1);
      this.advertisements.Displayed = this.advertisements.MediaBasico.slice(0,this.advertisements.Rows);
      this.advertisements.Random = this.services.NumberRandom(this.advertisements.Principal.length);
      this.services.postAdvertisementUser(this.advertisements.getAllRelAdsMetricsIdDisplayed());
    }
  }
  isSharing:boolean = false;
  calcular() {
    if (this.velocity.get('tipo').value === 'Diámetro') {
      this.result = Math.round((this.velocity.get('valor').value * this.velocity.get('cantidad').value) / 3.8197);
      this.mensaje = 'ft/min';
    } else {
      this.result = Math.round((this.velocity.get('valor').value * this.velocity.get('cantidad').value) / 318.3091);
      this.mensaje = 'm/min';
    }
    if(this.previousResult != this.result && !this.isSharing){
      this.previousResult = this.result;
      this.isSharing = true;
      setTimeout(()=>{ this.isSharing = false; },20000);
      this.services.addPointCalculator();
    }
  }

  home() {
    return this.router.navigate(['/calculadora']);
  }

  routesTab(option: number) {
    switch (option){
      case 1: this.router.navigate(['/revo']); break;
      case 2: this.router.navigate(['/velocity']); break;
      case 3: this.router.navigate(['/avan']); break;
      case 4: this.router.navigate(['/marche']); break;
      case 5: this.router.navigate(['/torneado']); break;
    }
  }

  cemPulg( valor: number) {
    return valor * 25.4;
      
  }

  PulugCem(valor: number){
    return (.1 * valor) / 2.54; 
  }

}
